import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Spinner,
  Divider,
} from "@chakra-ui/react";
import Login from "../../../../services/loginApi";
import TransferApiDireto from "../../../../services/TransferApiDireto";
import { toast } from "react-toastify";
import bancos from "bancos-brasileiros";
import { useNavigate } from "react-router-dom";
import { goToTransferSolicitationListNew } from "../../../../routes/coordinator";
import { NumericFormat } from "react-number-format";
import { BLACK } from "../../../../constants/colors";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../../routes/privateRoute";

const ModalSendACodeToLogin = ({
  isOpen,
  setIsOpen,
  functionPai,
  setCode,
  type,
  email,
  transferData,
}: any) => {
  const finalRef = useRef(null);
  const navigate = useNavigate();
  const [confirmation, setConfirmation] = useState(false);
  const [codes, setCodes] = useState<string[]>(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(true);
  const [transferResponse, setTransferResponse] = useState<any>(null);
  const [errors, setErrors] = useState<any[]>([]);
  const inputsRef = useRef<HTMLInputElement[]>([]);
  const [transferId, setTransferId] = useState<number | null>(null);
  const [statusSucesso, setStatusSucesso] = useState(true);
  const [manualValue, setManualValue] = useState<number>(0);
  const [isManualMode, setIsManualMode] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    setTransferResponse(null);
    setCodes(["", "", "", "", "", ""]);
    setConfirmation(false);
    setErrors([]);
    setManualValue(0);
    setStatusSucesso(true);
  };

  function formatDocumentNumber(number: any) {
    const unmaskedNumber = number.replace(/\D/g, "");
    if (number.includes("*")) {
      return number;
    }
    if (unmaskedNumber.length === 11) {
      return unmaskedNumber.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        "$1.$2.$3-$4"
      );
    } else if (unmaskedNumber.length === 14) {
      return unmaskedNumber.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    } else {
      return number;
    }
  }

  const unMask = (value: string | number) => {
    if (typeof value !== "string" && typeof value !== "number") {
      return 0;
    } else if (typeof value == "number") return value;

    let valorSemSimbolo = value.replace("R$ ", "");
    let valorSemPontos = valorSemSimbolo.replace(",", ".");
    if (
      !valorSemPontos ||
      valorSemPontos == "" ||
      valorSemPontos == undefined ||
      valorSemPontos == null
    ) {
      return 0;
    }

    return parseFloat(valorSemPontos);
  };

  const fetchTransferData = async () => {
    setLoading(true);
    setErrors([]);

    let manualMode = false;
    const token = window.localStorage.getItem("token");

    if (token) {
      try {
        const decoded: JWTToken = jwt_decode(token);
        if (decoded.loginPermissoes) {
          const loginPermissoes: number[] = JSON.parse(decoded.loginPermissoes);
          manualMode = loginPermissoes.includes(41);
        }
      } catch (error) { }
    }

    setIsManualMode(manualMode);

    try {
      const response = await TransferApiDireto.postTransferSolicitation({
        ...transferData,
        chavePix: ["CNPJ", "CPF", "CELULAR"].includes(transferData.tipoChave)
          ? unmaskChavePix(transferData.chavePix)
          : transferData.chavePix,
      });

      setStatusSucesso(false);
      setTransferId(response.idTransferencia);
      setTransferResponse(response);

      if (response.totalValue > 0) {
        setManualValue(response.totalValue);
      } else {
        setManualValue(0);
      }

      setLoading(false);

      if (!manualMode) {
        handleConfirmation(true);
      }
    } catch (error: any) {
      setStatusSucesso(true);
      if (
        error.response &&
        error.response.data &&
        error.response.data._errors
      ) {
        setErrors(error.response.data._errors);
      } else {
        handleClose();
        toast.error(
          `Falha ao solicitar transferência: ${error?.response?.data || error.message
          }`
        );
      }
      setLoading(false);
    }
  };

  const handleCancelTransfer = async () => {
    setManualValue(0);
    setTransferResponse(null);
    handleClose();
  };

  const handleConfirmation = async (confirm: boolean) => {
    if (confirm) {
      setConfirmation(true);
      try {
        await Login.GetNewCodeEmail(type, email);
        toast.success(
          "Você receberá um e-mail ou SMS com o código de segurança!"
        );
      } catch (error) {
        toast.error(`Falha ao solicitar código de segurança: ${error}`);
      }
    } else {
      handleClose();
    }
  };

  const handleChange = (index: number, value: string) => {
    const newCodes = [...codes];
    newCodes[index] = value.replace(/\D/g, "").slice(0, 1);
    setCodes(newCodes);
    if (value && index < codes.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && !codes[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async () => {
    const code = codes.join("");
    setCode(code);
    setLoading(true);
    setErrors([]);
    try {
      const valorPagamentoDesformatado =
        transferResponse.totalValue > 0
          ? transferResponse.totalValue
          : unMask(manualValue);

      await TransferApiDireto.confirmTransfer(
        transferResponse.idTransferencia,
        code,
        valorPagamentoDesformatado,
        transferResponse.tipoChave
      );
      handleClose();
      goToTransferSolicitationListNew(navigate);
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data._errors
      ) {
        setErrors(error.response.data._errors);
      } else {
        toast.error(
          `Falha ao confirmar transferência: ${error?.response?.data || error.message
          }`
        );
      }
      setLoading(false);
      handleClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setConfirmation(false);
      setCodes(["", "", "", "", "", ""]);
      fetchTransferData();
    }
  }, [isOpen]);

  const renderErrors = (errors: any[]) => {
    return (
      <Flex direction="column" alignItems="center" mt={4}>
        {errors.map((error, index) => (
          <Text key={index} color="red.500">
            {error._message}
          </Text>
        ))}
      </Flex>
    );
  };

  const unmaskChavePix = (chavePix: string) => {
    return chavePix.replace(/\D/g, "");
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const paste: any = event.clipboardData.getData("text").slice(0, 6);
    const newCodes: any = [...paste].map((char) => char.replace(/\D/g, ""));
    setCodes(newCodes);

    newCodes.forEach((value: any, index: any) => {
      if (inputsRef.current[index]) {
        inputsRef.current[index].value = value;
      }
    });

    const nextIndex = paste.length < 6 ? paste.length : 5;
    if (inputsRef.current[nextIndex]) {
      inputsRef.current[nextIndex].focus();
    }
  };

  const getBankName = (bankCode: string) => {
    const bank = bancos.find((banco) => banco.COMPE == bankCode.substring(1));
    if (bank) {
      return `${bank.COMPE} - ${bank.ShortName} `;
    } else {
      return `${bankCode}`;
    }
  };

  return (
    <Modal
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={handleClose}
      size={"xl"}
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalHeader>
          <Flex w={"100%"} justifyContent={"center"} my={2}>
            <Text fontSize={"xl"} fontWeight={"bold"}>
              {isManualMode
                ? "Transferência Gerada com Sucesso!"
                : !confirmation
                  ? loading
                    ? "Carregando..."
                    : "Você tem certeza que deseja transferir?"
                  : "Digite seu código de verificação"}
            </Text>
          </Flex>
        </ModalHeader>
        <ModalBody>
          {loading ? (
            <Flex justifyContent="center" alignItems="center" height="200px">
              <Spinner size="xl" />
            </Flex>
          ) : isManualMode ? (
            <Flex direction="column" alignItems="left">
              {errors.length > 0 && renderErrors(errors)}
              {transferResponse && transferResponse.beneficiary && (
                <Flex direction="column" alignItems="left">
                  <Text>
                    <strong>Nome do Beneficiário:</strong>{" "}
                    {transferResponse.beneficiary.name.toUpperCase()}
                  </Text>
                  <Text>
                    <strong>Tipo de Documento:</strong>{" "}
                    {transferResponse.beneficiary.documentType}
                  </Text>
                  <Text>
                    <strong>Número do Documento:</strong>{" "}
                    {formatDocumentNumber(
                      transferResponse.beneficiary.documentNumber
                    )}
                  </Text>
                  <Text>
                    <strong>Observação:</strong>{" "}
                    {transferResponse.beneficiary.observation}
                  </Text>
                  {getBankName(transferResponse.beneficiary.bankCode) !==
                    "0000" && (
                      <Text>
                        <strong>Banco:</strong>{" "}
                        {getBankName(transferResponse.beneficiary.bankCode)}
                      </Text>
                    )}
                </Flex>
              )}
              {errors.length === 0 && transferData.tipoPix === "CHAVE" && (
                <Flex direction="column" alignItems="left">
                  <Text>
                    <strong>Chave PIX:</strong> {transferData.chavePix}
                  </Text>
                </Flex>
              )}
              {errors.length === 0 && transferData.tipoPix === "CONTA" && (
                <Flex direction="column" alignItems="left">
                  <Text>
                    <strong>Agência:</strong> {transferData.nroAgencia}
                  </Text>
                  <Text>
                    <strong>Conta:</strong> {transferData.nroConta}-
                    {transferData.nroContaDigito}
                  </Text>
                  <Text>
                    <strong>Tipo de Conta:</strong>{" "}
                    {transferData.idTipoConta === 1 ? "Corrente" : "Poupança"}
                  </Text>
                  <Text>
                    <strong>Observação:</strong> {transferData.observacao}
                  </Text>
                </Flex>
              )}
              <br />
              <Divider variant="solid" color={BLACK}></Divider>
              {errors.length === 0 && (
                <Flex direction="column" alignItems="center" width={"100%"}>
                  <Text>
                    <strong>Valor Pagamento:</strong>{" "}
                    {transferResponse &&
                      (transferResponse.tipoChave !== "EMV" ||
                        transferResponse.totalValue > 0) ? (
                      transferResponse &&
                      transferResponse.totalValue &&
                      transferResponse.totalValue.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    ) : (
                      <>
                        <strong>Qr Code sem valor determinado.</strong>
                        <Text fontSize="sm" color="gray.500">
                          Valor definido: R$ {manualValue.toFixed(2)}
                        </Text>
                      </>
                    )}
                  </Text>
                </Flex>
              )}
            </Flex>
          ) : (
            <Flex direction="column" alignItems="left">
              {errors.length > 0 && renderErrors(errors)}
              {transferResponse && transferResponse.beneficiary && (
                <Flex direction="column" alignItems="left">
                  <Text>
                    <strong>Nome do Beneficiário:</strong>{" "}
                    {transferResponse.beneficiary.name.toUpperCase()}
                  </Text>
                  <Text>
                    <strong>Tipo de Documento:</strong>{" "}
                    {transferResponse.beneficiary.documentType}
                  </Text>
                  <Text>
                    <strong>Número do Documento:</strong>{" "}
                    {formatDocumentNumber(
                      transferResponse.beneficiary.documentNumber
                    )}
                  </Text>
                  <Text>
                    <strong>Observação:</strong>{" "}
                    {transferResponse.beneficiary.observation}
                  </Text>
                  {getBankName(transferResponse.beneficiary.bankCode) !==
                    "0000" && (
                      <Text>
                        <strong>Banco:</strong>{" "}
                        {getBankName(transferResponse.beneficiary.bankCode)}
                      </Text>
                    )}
                </Flex>
              )}
              {errors.length === 0 && transferData.tipoPix === "CHAVE" && (
                <Flex direction="column" alignItems="left">
                  <Text>
                    <strong>Chave PIX:</strong> {transferData.chavePix}
                  </Text>
                </Flex>
              )}
              {errors.length === 0 && transferData.tipoPix === "CONTA" && (
                <Flex direction="column" alignItems="left">
                  <Text>
                    <strong>Agência:</strong> {transferData.nroAgencia}
                  </Text>
                  <Text>
                    <strong>Conta:</strong> {transferData.nroConta}-
                    {transferData.nroContaDigito}
                  </Text>
                  <Text>
                    <strong>Tipo de Conta:</strong>{" "}
                    {transferData.idTipoConta === 1 ? "Corrente" : "Poupança"}
                  </Text>
                  <Text>
                    <strong>Observação:</strong> {transferData.observacao}
                  </Text>
                </Flex>
              )}
              <br />
              <Divider variant="solid" color={BLACK}></Divider>
              {errors.length === 0 && (
                <Flex direction="column" alignItems="center" width={"100%"}>
                  <Text>
                    <strong>Valor Pagamento:</strong>{" "}
                    {transferResponse &&
                      (transferResponse.tipoChave !== "EMV" ||
                        transferResponse.totalValue > 0) ? (
                      transferResponse &&
                      transferResponse.totalValue &&
                      transferResponse.totalValue.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    ) : (
                      <>
                        <strong>Qr Code sem valor determinado.</strong>
                        <NumericFormat
                          decimalScale={2}
                          prefix="R$ "
                          value={
                            manualValue !== null ? manualValue.toString() : ""
                          }
                          decimalSeparator=","
                          customInput={Input}
                          type="text"
                          placeholder="R$ 0,00"
                          onChange={(e: any) => {
                            setManualValue(e.target.value);
                          }}
                        />
                        {!(unMask(manualValue.toString()) > 0) && (
                          <Text fontSize="sm" color="gray.500">
                            É necessário definir um valor para seguir com o
                            pagamento.
                          </Text>
                        )}
                        <br />
                      </>
                    )}
                  </Text>
                </Flex>
              )}
              <Flex w={"100%"} justifyContent={"center"} mt={4}>
                {codes.map((value, index) => (
                  <Input
                    key={index}
                    ref={(el) =>
                      (inputsRef.current[index] = el as HTMLInputElement)
                    }
                    type="text"
                    maxLength={1}
                    width="3rem"
                    textAlign="center"
                    value={value}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    marginRight={2}
                    borderColor="blue.500"
                    _focus={{ borderColor: "blue.700" }}
                  />
                ))}
              </Flex>
            </Flex>
          )}
        </ModalBody>
        <ModalFooter justifyContent={"space-evenly"}>
          {isManualMode ? (
            <Button
              colorScheme="blue"
              onClick={() => {
                handleClose();
                goToTransferSolicitationListNew(navigate);
              }}
            >
              OK
            </Button>
          ) : (
            <>
              {!confirmation ? (
                <Flex>
                  <Button
                    m={2}
                    onClick={() => handleConfirmation(true)}
                    colorScheme="blue"
                    disabled={
                      errors.length > 0 ||
                      statusSucesso ||
                      unMask(manualValue) <= 0
                    }
                  >
                    Confirmar
                  </Button>
                  <Button
                    m={2}
                    onClick={handleCancelTransfer}
                    colorScheme="gray"
                  >
                    Cancelar
                  </Button>
                </Flex>
              ) : (
                <Button
                  mt={4}
                  onClick={handleSubmit}
                  disabled={codes.some((code) => !code)}
                >
                  Confirmar código
                </Button>
              )}
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalSendACodeToLogin;
